import styled from "styled-components";
import { COLORS } from "../../../../../../layout/theme";
import { Table } from "antd";

export const AntdTable = styled(Table)`
  .ant-table-thead > tr > th {
    background: ${(props) => (props.background ? props.background : COLORS.Primary)};
  }

  .ant-table-row {
    background: ${(props) => (props.rowBackground ? props.rowBackground : COLORS.White)};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${(props) => (props.background ? props.background : COLORS.Primary)};

    div {
      color: ${(props) => (props.background ? props.background : COLORS.Primary)};
    }
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-radius: 20px 0 0 0;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-radius: 0 20px 0 0;
  }

  }
`;

export const TableContainer = styled.div`
	margin-top: ${(props) =>
		props.containerMarginTop ? props.containerMarginTop : "0px"};

	.ant-table table {
		background-color: ${(props) =>
			props.containerBackground
				? props.containerBackground
				: COLORS.LightGrey} !important;
	}
`;
